# Field changes

The same drift as the Records tab, counted by field rather than by record.

This is where systemic loss shows up: a field emptied in one record is noise, and
the same field emptied across every matched record is a scraper regression. The
engine flags the second at 100% loss, unless this source's profile declares a
lower threshold its owner approved. None ships with one: no measurement here
establishes where partial loss stops being churn, so no threshold is invented
for a source whose owner has not set one.

Fill rate is the share of records where the field carries a value. Compare the
two columns rather than reading either alone.
